module.exports = __webpack_public_path__ + "media/images/logo-wordmark-white-9927c1da57ad1c51000b53222a3a075a.svg";